//
import { getStorage, setStorage } from '../storage';
import { ACCESS_TOKEN, IS_THIRD_CHECK, IS_THIRD_FLAG } from '../../store/types';



export const onApplicationApplyCheck = async (app, callback) => {
  const { id, thirdFlag, thirdCheck, thirdCheckUrl, applicationUrl, openType } = app || {};

  await handleValidateSignInStatus(
    // eslint-disable-next-line consistent-return
    () => {
      // 是否為第三方應用
      if([IS_THIRD_FLAG.False].includes(thirdFlag)){
        handleUserAppRelationInformation(app, callback);
      } else {
        // 第三方的应用是否需要審核
        // eslint-disable-next-line no-lonely-if
        if([IS_THIRD_CHECK.True].includes(thirdCheck)) {
          return handleThirdCheck(thirdCheckUrl);
        }
        // 第三方的应用直接打开
        handleThirdLink(applicationUrl?.includes('?') ? `${applicationUrl}&id=${id}` : `${applicationUrl}?id=${id}`, openType)
      }
    }, () => {
      // store.dispatch('AuthInShow').then(r => {})
    });
  await handleClickByApplication(id);
};


// 驗證登錄狀態
const handleValidateSignInStatus = (success, error) => {
  const token = getStorage(ACCESS_TOKEN);
  if(token) {
    success();
  } else {
    error();
  }
};

// 是否綁定應用(查詢用戶與應用關聯)
const handleUserAppRelationInformation = (app, callback) => {
};

// 應用跳轉
const handleApplicationLink = (url, code, openType = '_blank') => {
}

// 第三方应用審核
const handleThirdCheck = (url) => {
  const token = getStorage(ACCESS_TOKEN);
  // window.open('http://10.139.100.111:3800/s365h5/support/users/platadmin', 'Support', 'height=800,width=800');
  // http://10.134.163.93:9996/
  // var win = window.open('', '_blank', 'height=600, width=800, top=200, left=200, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no');
  // window.open('Sub.htm', '_blank', 'height=600, width=800, top=200, left=200, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no');
  // window.open('http://10.139.100.111:3800/s365h5/support/users/platadmin', '_blank', 'noopener,noreferrer,resizable')

  // http://10.139.100.111:3800/s365h5/support/users/platadmin
  // let myWindow = window.open("", "MsgWindow", "width=200,height=100");
  // window.close();
  const targetWindow = window.open(`${url}?token=${token}`, '_blank', 'height=600, width=800, top=200, left=200, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no');
  // targetWindow.opener.postMessage(JSON.stringify(params), "*");
  // targetWindow.postMessage(JSON.stringify(params), "*");
  // targetWindow.parent.postMessage(JSON.stringify(params), "*");
  // targetWindow.opener.postMessage(JSON.stringify(params), "*");


  // this.$refs['iframe']['contentWindow'].postMessage(JSON.stringify(params), '*')
};

// 第三方应用直接打开
const handleThirdLink = (url, openType = '_blank') => {
  window.open(url, `_${openType}`);
};

// 記錄應用點擊量
const handleClickByApplication = async (id) => {
}

// 記錄最近瀏覽
export const onRecentBrowse = async (id) => {

}


// 定義一個函數來保存最近瀏覽的項目
export const saveRecentItem = (item) => {

  // 從 localStorage 中獲取當前的瀏覽記錄
  let recentItems = getStorage('recentItems') || [];

  // 檢查是否已經存在相同的項目，如果存在則移除
  recentItems = recentItems.filter(i => i?.id !== item?.id);

  // 將新項目添加到數組的開頭
  recentItems.unshift(item);

  // 只保留最近的 5 個項目
  if (recentItems.length > 3) {
      recentItems = recentItems.slice(0, 3);
  }

  // 將更新後的數組保存回 localStorage
  setStorage('recentItems', recentItems);
};

// 定義一個函數來獲取最近瀏覽的項目
export const getRecentItems = () => {
  return getStorage('recentItems') || [];
}